
const contacts = [
    {
        name: 'Email',
        value: 'ondra.w08@gmail.com',
        type: 'mailto:',
        icon: '✉️'
    },
    {
        name: "Phone / Whatsapp",
        value: '+420 770 131 018',
        type: 'tel:',
        icon: '📱'
    },
    {
        name: 'LinkedIn',
        value: 'https://www.linkedin.com/in/ondřej-wislocki-8bba33394/',
        type: '',
        icon: '💼'
    },
    {
        name: 'GitHub',
        value: 'https://github.com/Wisla-15/',
        type: '',
        icon: '🐙'
    }
]

export default contacts